import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Popover,
} from "react-bootstrap";
import AdminApi from "../../api/admin";
import { toast } from "react-toastify";
import CustomDataTable from "../../components/CustomDataTable";
import Helpers from "../../components/Helpers";
import DeleteModel from "../../components/DeleteModel";
import { Cookies, useCookies } from "react-cookie";
import { utils, writeFile } from "xlsx";
import AlertModal from "../../components/AlertModel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Profile from "../../assets/images/couple-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import AuthApi from "../../api/authApi";
import UpdateCouplePopUp from "../common/UpdateCouplePopUp";
import { useLocation } from "react-router-dom";
import CopyIcon from "../../components/CopyIcon";
import CopyEmailsButton from "../../components/CopyEmailsButton";
import "../../assets/css/ManageCouplesModern.css";
const XLSX = require("xlsx");

const COUPLE_MISSING_LABEL = "⚠ Missing";

const isCoupleBlank = (value) => {
  if (value === null || value === undefined) return true;
  const text = String(value).trim();
  return text === "" || text.toLowerCase() === "null";
};

const COUPLE_TABLE_FIELDS = {
  hisLastName: "hisLastName",
  hisFirstName: "hisFirstName",
  hisEmail: "hisEmail",
  hisMobile: "hisMobile",
  herLastName: "herLastName",
  herFirstName: "herFirstName",
  herEmail: "herEmail",
  herMobile: "herMobile",
  Address: "address",
  Parish: "parish",
  city: "city",
  state: "state",
  zip: "zip",
  "Anniversary Date": "anniversary_date",
};

const isCoupleCellMissing = (row, field) => {
  if (!row || !field) return false;
  if (field === "parish") {
    return isCoupleBlank(row.parish) && isCoupleBlank(row.parishId);
  }
  return isCoupleBlank(row[field]);
};

const ManageCouples = () => {
  const locationData = useLocation();
  const [validated, setValidated] = useState(false);
  const [showRegModal, setShowREgModal] = useState(false);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [data, setData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    lastCoupleImage: "",
    parishId: null,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const [allCoupleData, setAllCoupleData] = useState([]);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [total, setTotal] = useState(20);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);
  const [icon_id, setIcon_id] = useState("");
  let adminApi = new AdminApi();
  let authApi = new AuthApi();
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const [cookie, setCookie] = useCookies(["LoveStrongUser"]);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [changeText, setChangeText] = useState("");
  const [LoadData, setLoadData] = useState(false);
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState([]);
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [parishList, setParishList] = useState([]);
  const [roasterCount, setRoasterCount] = useState("");
  const [oldValues, setOldValues] = useState([]);
  const [makeSubAdminValue, setMakeSubAdminValue] = useState({
    value: "",
    coupleId: "",
    adminType: "",
  });
  const [alreadyPk, setAlreadyPk] = useState();
  const [coupleRepeatMsg, setCoupleRepeatMsg] = useState("");

  const path = locationData.pathname;
  const lastSegment = path.split("/").filter(Boolean).pop();
  const [coupleFilter, setCoupleFilter] = useState(
    lastSegment === "missing-data" ? "1" : "0"
  );
  const openedAddFromQuery = useRef(false);

  useEffect(() => {
    setSearchKey("");
    if (locationData?.state?.parishValue) {
      getAllCouplesData(
        1,
        20,
        null,
        {},
        false,
        locationData?.state?.parishValue,
      );
    } else {
      getAllCouplesData(1, 20, null, {}, false, null);
    }
    getParishList();

  }, []);

  useEffect(() => {
    setSearchKey("");
    setCoupleFilter(lastSegment === "missing-data" ? "1" : "0");
    if (lastSegment === "missing-data") {
      getAllCouplesData(1, 20, null, {}, false, null);
    } else {
      if (locationData?.state?.parishValue) {
        getAllCouplesData(
          1,
          20,
          null,
          {},
          false,
          locationData?.state?.parishValue,
        );
      } else {
        getAllCouplesData(1, 20, null, {}, false, null);
      }
    }
  }, [lastSegment]);

  const checkPKCouple = async () => {
    await authApi
      .checkPKCouple()
      .then((res) => {
        if (res.success) {
          if (res.data != null) {
            let incPK = res.data + 1;
            setAlreadyPk(incPK);
            let d = { ...data };
            d.primaryKey = incPK;
            setData(d);
          } else {
            let defaultPK = 1001;
            setAlreadyPk(defaultPK);
            let d = { ...data };
            d.primaryKey = defaultPK;
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getParishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setParishList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const clearfield = () => {
    setData({
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      notes: "",
      imageUrl: "",
      lastCoupleImage: "",
      parishId: null,
      address: "",
      allergies: "",
      anniversary_date: "",
      under_age_35: "NO",
      emergency_name1: "",
      emergency_relationship1: "",
      emergency_phone1: "",
      emergency_name2: "",
      emergency_relationship2: "",
      emergency_phone2: "",
      hear_us: [],
      referral_from_a_friend_or_family_member: "",
    });
    setValidated(false);
  };

  useEffect(() => {
    if (openedAddFromQuery.current) return;
    const params = new URLSearchParams(locationData.search);
    if (params.get("add") !== "1") return;
    openedAddFromQuery.current = true;
    setShowREgModal(true);
    checkPKCouple();
    clearfield();
    params.delete("add");
    const next = params.toString();
    window.history.replaceState(
      {},
      "",
      `${locationData.pathname}${next ? `?${next}` : ""}${locationData.hash || ""}`,
    );
  }, [locationData.search, locationData.pathname, locationData.hash]);

  const getAllCouplesData = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
    parishValue = null,
  ) => {
    setLoadData(true);
    let d = { userRole: "COUPLE" };
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    if (parishValue) {
      d.parishValue = parishValue;
    }
    if (lastSegment === "missing-data") {
      d.withoutParishCouples = true;
    }

    d.export = false;
    await adminApi
      .getAllCouples(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          setAllCoupleData(res.data);
          setLoadData(false);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const allCouples = async () => {
    getAllCouplesData();
  };

  const missingCouples = async () => {
    await adminApi
      .getMissingData()
      .then((res) => {
        if (res.success) {
          setAllCoupleData(res.data);
          setTotal(res.totalRecords);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const handleSearchChanges = async (e) => {
    let { name, value } = e.target;
    if (e.target.value === "0") {
      allCouples();

    } else if (e.target.value === "1") {

      missingCouples();
    }
  };

  const applyCoupleFilter = (value) => {
    if (!value || value === coupleFilter) return;
    setCoupleFilter(value);
    handleSearchChanges({ target: { value } });
  };

  const getroastersOfCouple = async (id) => {
    await adminApi
      .participatedInRetreats({ couple_Id: id })
      .then(async (response) => {
        setRoastersOfCoupleList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const editCouple = async (id) => {
    setIsTempUpload(false);
    // setIsTempUpload2(false);
    setEdiUserIdClicked(id);
    let d = { ...data };
    await adminApi
      .getCouplesDetail({ coupleId: id })
      .then(async (res) => {
        if (
          res.data[0].hisEmail === "tkolkebeck@me.com" ||
          res.data[0].herEmail === "tkolkebeck@satx.rr.com" ||
          res.data[0].hisEmail === "jimmieflores@gmail.com" ||
          res.data[0].herEmail === "dulceaflores@gmail.com"
        ) {
          setIsEditAdmin(true);
        }
        if (res.success) {
          d.id = res.data[0].id;
          d.primaryKey = res.data[0].primaryKey;
          d.hisFirstName = res.data[0].hisFirstName;
          d.hisLastName = res.data[0].hisLastName;
          d.hisEmail = res.data[0].hisEmail;
          d.hisMobile = res.data[0].hisMobile;
          d.herFirstName = res.data[0].herFirstName;
          d.herLastName = res.data[0].herLastName;
          d.herEmail = res.data[0].herEmail;
          d.herMobile = res.data[0].herMobile;
          d.city = res.data[0].city;
          d.state = res.data[0].state;
          d.zip = res.data[0].zip;
          d.notes = res.data[0].notes;
          d.parishId = res.data[0].parishId;
          d.imageUrl = res.data[0].imageUrl;
          d.lastCoupleImage = res.data[0].lastCoupleImage;
          d.address = res.data[0].address;
          d.allergies = res.data[0].allergies;
          d.anniversary_date = res.data[0].anniversary_date
            ? new Date(res.data[0].anniversary_date)
            : "";
          d.under_age_35 = res.data[0].under_age_35;
          d.emergency_name1 = res.data[0].emergency_name1;
          d.emergency_relationship1 = res.data[0].emergency_relationship1;
          d.emergency_phone1 = res.data[0].emergency_phone1;
          d.emergency_name2 = res.data[0].emergency_name2;
          d.emergency_relationship2 = res.data[0].emergency_relationship2;
          d.emergency_phone2 = res.data[0].emergency_phone2;
          d.hear_us = res.data[0].hear_us;
          d.referral_from_a_friend_or_family_member =
            res.data[0].referral_from_a_friend_or_family_member;
          setData(d);
          setOldValues(res.data[0]);

        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const deleteCouple = async () => {
    await adminApi
      .deleteCouple({ couple_id: icon_id.id })
      .then(async (res) => {
        if (res.success) {
          getAllCouplesData();
          setShow(false);
          setIcon_id("");
          checkPKCouple();
          toast.success(res.msg);

        } else {
          checkPKCouple();
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const popover = (row) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                row.hisLastName +
                  ", " +
                  row.hisFirstName +
                  " and " +
                  row.herFirstName}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const columns = [
    {
      id: "action",
      name: "Action",
      button: true,
      cell: (row) => (
        <>
          {userData && userData.userRole === "ADMIN" && (
            <>
              <button
                className="font-size"
                onClick={() => {
                  editCouple(row.id);
                  setShowREgModal(true);
                  getroastersOfCouple(row.id);
                }}
              >
                <i
                  className="mdi mdi-pencil-box text-lg text-primary font-size"
                  title="Edit"
                ></i>
              </button>
              <button className="font-size" onClick={() => handleShow(row)}>
                <i
                  className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
                  title="Delete"
                ></i>
              </button>
            </>
          )}
          <CopyEmailsButton emails={[row.hisEmail, row.herEmail]} />
        </>
      ),
      reorder: true,
      width: userData && userData.userRole === "ADMIN" ? "140px" : "70px",
    },
    {
      id: "primaryKey",
      name: "Couple Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <OverlayTrigger placement="right" overlay={popover(row)}>
          {row.imageUrl ? (
            <span
              onClick={() => {
                editCouple(row.id);
                setShowREgModal(true);
                getroastersOfCouple(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img
                  src={row.imageUrl}
                  className="column-rowImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </span>
              {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
            </span>
          ) : (
            <span
              onClick={() => {
                editCouple(row.id);
                setShowREgModal(true);
                getroastersOfCouple(row.id);
              }}
            >
              <span className="roasterKey is-roster-missing" title="Missing Picture">
                {" "}
                <img src={Profile} className="column-rowImage-profile" />
              </span>

              {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
    },
    {
      id: "hisLastName",
      name: "His Last Name",
      selector: (row) => row.hisLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisLastName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.hisLastName &&
              row.hisLastName.slice(0, 10) +
                (row.hisLastName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "hisFirstName",
      name: "His First Name",
      selector: (row) => row.hisFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisFirstName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.hisFirstName &&
              row.hisFirstName.slice(0, 10) +
                (row.hisFirstName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "hisEmail",
      name: "His Email",
      selector: (row) => row.hisEmail,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1 w-100">
          <CopyIcon text={row.hisEmail} />
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(row.hisEmail)}
          >
            <span>
              {row.hisEmail &&
                row.hisEmail.slice(0, 12) +
                  (row.hisEmail.length > 12 ? "..." : "")}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      width:"150px",
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
      style: {
        backgroundColor: "#E0F8FE",
        cursor: "text",
      },
    },
    {
      id: "hisMobile",
      name: "His Mobile",
      selector: (row) => row.hisMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisMobile)}
        >
          <span>
            {row.hisMobile &&
              row.hisMobile.slice(0, 10) +
                (row.hisMobile.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
        cursor: "text",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herLastName",
      name: "Her Last Name",
      selector: (row) => row.herLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herLastName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.herLastName &&
              row.herLastName.slice(0, 10) +
                (row.herLastName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herFirstName",
      name: "Her First Name",
      selector: (row) => row.herFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herFirstName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.herFirstName &&
              row.herFirstName.slice(0, 10) +
                (row.herFirstName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herEmail",
      name: "Her Email",
      selector: (row) => row.herEmail,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1 w-100">
          <CopyIcon text={row.herEmail} />
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(row.herEmail)}
          >
            <span>
              {row.herEmail &&
                row.herEmail.slice(0, 12) +
                  (row.herEmail.length > 12 ? "..." : "")}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
       width:"150px",
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herMobile",
      name: "Her Mobile",
      selector: (row) => row.herMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herMobile)}
        >
          <span>
            {row.herMobile &&
              row.herMobile.slice(0, 10) +
                (row.herMobile.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
        cursor: "text",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.address)}
        >
          <span>
            {row.address &&
              row.address.slice(0, 10) + (row.address.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => row.parish,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.parish)}
        >
          <span>{row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "220px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.city)}
        >
          <span>
            {row.city &&
              row.city.slice(0, 10) + (row.city.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.state)}
        >
          <span>
            {row.state &&
              row.state.slice(0, 10) + (row.state.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Anniversary Date",
      name: "Anniversary Date",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
          )}
        >
          <span>
            {row.anniversary_date
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY")
              : "--"}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "DD-MM-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    ...(userData && userData.userRole === "SUBADMIN"
      ? [
          {
            id: "status",
            name: "Status",
            selector: (row) =>
              row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1),
            reorder: true,
          },
        ]
      : []),
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "status",
            name: "Status",
            selector: (row) =>
              row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1),
            cell: (row) => (
              <Form.Select
                size="sm"
                value={row.accountStatus}
                onChange={(e) => changeStatus(row.id, e.target.value)}
                className="selectData"
              >
                <option value="ACTIVE">Active</option>
                <option value="DECEASED">Deceased</option>
                <option value="DIVORCED">Divorced</option>
                <option value="INACTIVE">Inactive</option>
              </Form.Select>
            ),
            reorder: true,
          },
          {
            id: "makeSubAdmin",
            name: "Sub Admin?",
            selector: (row) => {
              if (
                row.accountStatus === "ACTIVE" &&
                (row.hisEmail || row.herEmail)
              ) {
                if (
                  row.hisEmail !== "tkolkebeck@me.com" &&
                  row.herEmail !== "tkolkebeck@satx.rr.com" &&
                  row.hisEmail !== "jimmieflores@gmail.com" &&
                  row.herEmail !== "dulceaflores@gmail.com"
                ) {
                  return (
                    <Form.Check
                      className="switchSize"
                      type="switch"
                      name="makeCoupleAsSubAdmin"
                      value={row.isAdminRight}
                      checked={row.isAdminRight}
                      onChange={(e) => {
                        handleShow1(e.target.value, row, "SUBADMIN");
                      }}
                      id="makeCoupleAsSubAdmin"
                    />
                  );
                }
              }
            },
            reorder: true,
          },
          {
            id: "makeAdmin",
            name: "Super Admin?",
            selector: (row) => {
              if (
                row.accountStatus === "ACTIVE" &&
                (row.userRole === "SUBADMIN" || row.userRole === "ADMIN")
              ) {
                if (
                  row.hisEmail !== "tkolkebeck@me.com" &&
                  row.herEmail !== "tkolkebeck@satx.rr.com" &&
                  row.hisEmail !== "jimmieflores@gmail.com" &&
                  row.herEmail !== "dulceaflores@gmail.com"
                ) {
                  return (
                    <Form.Check
                      className="switchSize"
                      type="switch"
                      name="makeCoupleAsAdmin"
                      value={row.userRole === "ADMIN" ? 1 : 0}
                      checked={row.userRole === "ADMIN" ? 1 : 0}
                      onChange={(e) => {
                        handleShow2(e.target.value, row, "ADMIN");
                      }}
                      id="makeCoupleAsAdmin"
                    />
                  );
                }
              }
            },
            reorder: true,
          },
        ]
      : []),
  ].map((column) => {
    const field = COUPLE_TABLE_FIELDS[column.id];
    if (!field) return column;
    const coupleMissingStyles = [
      {
        when: (row) => isCoupleCellMissing(row, field),
        style: {
          backgroundColor: "#ffff00",
          color: "#111827",
        },
      },
      ...((column.conditionalCellStyles || []).map((style) => ({
        ...style,
        when: (row) =>
          typeof style.when === "function"
            ? style.when(row) && !isCoupleCellMissing(row, field)
            : false,
      }))),
    ];
    const originalCell = column.cell;
    return {
      ...column,
      conditionalCellStyles: coupleMissingStyles,
      cell: (row, index, col, id) => {
        if (isCoupleCellMissing(row, field)) {
          return (
            <span className="mc-missing-text" title="Missing Couple data">
              {COUPLE_MISSING_LABEL}
            </span>
          );
        }
        return originalCell
          ? originalCell(row, index, col, id)
          : row[field];
      },
    };
  });

  const changeStatus = (id, value) => {
    adminApi
      .changeStatus({ id: id, value: value })
      .then((res) => {
        getAllCouplesData();


        toast.success(res.msg);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const makeCoupleAsSubAdmin = () => {
    if (
      makeSubAdminValue &&
      makeSubAdminValue.value !== "" &&
      makeSubAdminValue.coupleId !== ""
    ) {
      let value;
      if (makeSubAdminValue.value === "1") {
        value = 0;
      } else {
        value = 1;
      }
      adminApi
        .makeCoupleAsSubAdmin({
          value: value,
          id: makeSubAdminValue.coupleId,
          adminType: makeSubAdminValue.adminType,
        })
        .then((res) => {


          getAllCouplesData();
          toast.success(res.msg);
          handleClose1();
          handleClose2();
        })
        .catch((error) => {
          toast.error(error);
          let d = { ...makeSubAdminValue };
          d.value = "";
          d.coupleId = "";
          d.adminType = "";
          setMakeSubAdminValue(d);
        });
    }
  };

  const handleShow1 = (value, row, adminType) => {
    if (row.isAdminRight) {
      setChangeText("remove");
    } else {
      setChangeText("");
    }
    setShow1(true);
    let d = { ...makeSubAdminValue };
    d.value = value;
    d.coupleId = row.id;
    d.adminType = adminType;
    setMakeSubAdminValue(d);
  };

  const handleShow2 = (value, row, adminType) => {
    if (row.isAdminRight && row.userRole == "ADMIN") {
      setChangeText("remove");
    } else {
      setChangeText("");
    }
    setShow2(true);
    let d = { ...makeSubAdminValue };
    d.value = value;
    d.coupleId = row.id;
    d.adminType = adminType;
    setMakeSubAdminValue(d);
  };

  const handleShow = (item) => {
    setShow(true);
    setIcon_id(item);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleClose1 = () => {
    setChangeText("");
    setShow1(false);
    let d = { ...makeSubAdminValue };
    d.value = "";
    d.coupleId = "";
    d.adminType = "";
    setMakeSubAdminValue(d);
  };

  const handleClose2 = () => {
    setChangeText("");
    setShow2(false);
    let d = { ...makeSubAdminValue };
    d.value = "";
    d.coupleId = "";
    d.adminType = "";
    setMakeSubAdminValue(d);
  };

  const handleClose3 = () => {
    setShow3(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  const SearchData = (event) => {
    const key = event.target.value;
    if (key !== "") {
      setSearchKey(event.target.value);
      getAllCouplesData(
        1,
        20,
        event.target.value,
        {},
        false,
        locationData?.state?.parishValue,
      );
    } else {
      setSearchKey("");
      getAllCouplesData(1, 20, "", {}, false, locationData?.state?.parishValue);
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        row.accountStatus === "DECEASED" ||
        row.accountStatus === "DIVORCED" ||
        row.accountStatus === "INACTIVE",
      style: {
        backgroundColor: "#f8d7da",
        color: "#000",
        borderColor: "#dfc2c4",
      },
    },
  ];

  const handleExport = async () => {
    let d = { userRole: "COUPLE" };
    d.pageNo = 1;
    d.size = 20;
    d.export = true;
    await adminApi
      .getAllCouples(d)
      .then(async (res) => {
        if (res.success) {
          let exportData = [];
          res.data.forEach((element) => {
            exportData.push({
              primaryKey: element.primaryKey,
              hisFirstName: element.hisFirstName,
              hisLastName: element.hisLastName,
              hisEmail: element.hisEmail,
              hisMobile: element.hisMobile,
              herFirstName: element.herFirstName,
              herLastName: element.herLastName,
              herEmail: element.herEmail,
              herMobile: element.herMobile,
              address: element.address,
              city: element.city,
              state: element.state,
              zip: element.zip,
              parish: element.parish,
              Anniversary_date:
                element.anniversary_date !== null
                  ? Helpers.convertUtcToTimezone(
                      element.anniversary_date,
                      "MM-DD-YYYY",
                    )
                  : "",
              Dietary_restrictions_or_physical_limitations: element.allergies,
              Under_age_35: element.under_age_35,
              Emergency_name1: element.emergency_name1,
              Emergency_relationship1: element.emergency_relationship1,
              Emergency_phone1: element.emergency_phone1,
              Emergency_name2: element.emergency_name2,
              Emergency_relationship2: element.emergency_relationship2,
              Emergency_phone2: element.emergency_phone2,
              // How_did_you_hear_about_us: element.hear_us,
              Referral_from_a_friend_or_family_member:
                element.referral_from_a_friend_or_family_member,
              notes: element.notes,
            });
          });
          const headings = [
            [
              "Couple Id",
              "His First Name",
              "His Last Name",
              "His Email",
              "His Mobile",
              "Her First Name",
              "Her Last Name",
              "Her Email",
              "Her Mobile",
              "Address",
              "City",
              "State",
              "Zip",
              "Parish",
              "Anniversary Date",
              "Dietary Restrictions Or Physical Limitations",
              "Under Age 35",
              "Emergency Name1",
              "Emergency Relationship1",
              "Emergency Phone1",
              "Emergency Name2",
              "Emergency Relationship2",
              "Emergency Phone2",
              "How did you hear about us?",
              "Referral from a friend/family member",
              "Notes",
            ],
          ];
          const wb = utils.book_new();
          const ws = utils.json_to_sheet([]);
          utils.sheet_add_aoa(ws, headings);
          utils.sheet_add_json(ws, exportData, {
            origin: "A2",
            skipHeader: true,
          });
          utils.book_append_sheet(wb, ws, "Data");
          writeFile(wb, "Couple Data.xlsx");

        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const exportPdf = async () => {
    const unit = "pt";
    const size = "A1"; // large page for wide data
    const orientation = "landscape"; // ✅ changed to landscape
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = "All Couples";

    const headers = [
      [
        "Couple Id",
        "His First Name",
        "His Last Name",
        "His Email",
        "His Mobile",
        "Her First Name",
        "Her Last Name",
        "Her Email",
        "Her Mobile",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    let d = { userRole: "COUPLE" };
    d.pageNo = 1;
    d.size = 20;
    d.export = true;

    await adminApi
      .getAllCouples(d)
      .then(async (res) => {
        if (res.success) {
          const data = res.data.map((element) => [
            element.primaryKey,
            element.hisFirstName,
            element.hisLastName,
            element.hisEmail,
            element.hisMobile,
            element.herFirstName,
            element.herLastName,
            element.herEmail,
            element.herMobile,
            element.address,
            element.city,
            element.state,
            element.zip,
            element.parish,
            element.anniversary_date !== null
              ? Helpers.convertUtcToTimezone(
                  element.anniversary_date,
                  "MM-DD-YYYY",
                )
              : "",
            element.allergies,
            element.under_age_35,
            element.emergency_name1,
            element.emergency_relationship1,
            element.emergency_phone1,
            element.emergency_name2,
            element.emergency_relationship2,
            element.emergency_phone2,
            element.referral_from_a_friend_or_family_member,
            element.notes,
          ]);

          let content = {
            head: headers,
            body: data,
            startY: 70,
            theme: "grid",
            tableLineColor: [189, 195, 199],
            tableLineWidth: 0.75,
            styles: {
              fontSize: 9,
              cellPadding: 3,
              overflow: "linebreak",
              cellWidth: "wrap",
            },
            headStyles: {
              fillColor: [22, 160, 133],
              textColor: [255, 255, 255],
              fontSize: 9,
            },
            // ✅ Wider column widths for landscape layout
            columnStyles: {
              0: { cellWidth: 50 },
              1: { cellWidth: 70 },
              2: { cellWidth: 70 },
              3: { cellWidth: 120 },
              4: { cellWidth: 80 },
              5: { cellWidth: 70 },
              6: { cellWidth: 70 },
              7: { cellWidth: 120 },
              8: { cellWidth: 80 },
              9: { cellWidth: 100 },
              10: { cellWidth: 70 },
              11: { cellWidth: 50 },
              12: { cellWidth: 60 },
              13: { cellWidth: 70 },
              14: { cellWidth: 100 },
              15: { cellWidth: 70 },
              16: { cellWidth: 100 },
              17: { cellWidth: 100 },
              18: { cellWidth: 90 },
              19: { cellWidth: 100 },
              20: { cellWidth: 100 },
              21: { cellWidth: 90 },
              22: { cellWidth: 120 },
              23: { cellWidth: 130 },
              24: { cellWidth: 130 },
            },
            tableWidth: "wrap",
            margin: { left: marginLeft, right: 40 },
          };

          doc.text(title, marginLeft, 40);
          doc.autoTable(content);
          doc.save("report.pdf");


        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  function isXLSXFile(file) {
    return file.name.endsWith(".xlsx");
  }

  const fileChangeListener = (event) => {
    const text = [];
    let files = [];
    files = event.target.files;
    if (files && files.length && isXLSXFile(files[0])) {
      const input = event.target;
      const reader = new FileReader();
      reader.readAsBinaryString(input.files[0]);

      reader.onload = (e) => {
        const exportData = [];
        const xlsxData = reader.result;
        processXLSXCoupleRecord(xlsxData);
      };
      reader.onerror = function () {
        alert("Unable to read " + input.files[0]);
      };
    } else {
      toast.error("Please import valid .xlsx file.");
    }
  };

  const processXLSXCoupleRecord = (xlsxRecordsArray) => {
    try {
      const workbook = XLSX.read(xlsxRecordsArray, { type: "binary" });
      const sheet_name_list = workbook.SheetNames;
      const data = [];
      sheet_name_list.forEach(function (y) {
        const worksheet = workbook.Sheets[y];
        const headers = {};
        for (let z in worksheet) {
          if (z[0] === "!") continue;
          // parse out the column, row, and value
          let tt = 0;
          for (let i = 0; i < z.length; i++) {
            if (!isNaN(z[i])) {
              tt = i;
              break;
            }
          }
          const col = z.substring(0, tt);
          const row = parseInt(z.substring(tt));
          const value = worksheet[z].v;
          // store header names
          if (row == 1 && value) {
            headers[col] = value;
            continue;
          }
          if (!data[row]) {
            data[row] = {};
          }
          data[row][headers[col]] = value;
        }
      });

      if (data && data.length) {
        let importedData = [];
        // if (!data[2]["Couple Id"]) {
        //   toast.error("Couple Id Header is missing in Excel");
        //   // setProcessing(false);
        //   return false;
        // }
        data.forEach(function (value, index) {
          const obj = {};
          // if (value["Couple Id"] == '') {
          //   toast.error("Couple Id value missing. Check near line " + index + 1);
          //   // setProcessing(false);
          //   return false;
          // }
          if (value["Couple Id"]) {
            // && value["His Last Name"] && value["His Email"] && value["His Mobile"] && value["Her First Name"] && value["Her Last Name"] && value["Her Email"] && value["Her Mobile"]
            obj.primaryKey = value["Couple Id"];
            obj.hisFirstName = value["His First Name"]
              ? value["His First Name"]
              : "";
            obj.hisLastName = value["His Last Name"]
              ? value["His Last Name"]
              : "";
            obj.hisEmail = value["His Email"] ? value["His Email"] : "";
            obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";

            obj.herFirstName = value["Her First Name"]
              ? value["Her First Name"]
              : "";
            obj.herLastName = value["Her Last Name"]
              ? value["Her Last Name"]
              : "";
            obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
            obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
            obj.address = value["Address"] ? value["Address"] : "";
            obj.city = value["City"] ? value["City"] : "";
            obj.state = value["State"] ? value["State"] : "";
            obj.zip = value["Zip"] ? value["State"] : "";
            obj.anniversary_date = value["Anniversary Date"]
              ? value["Anniversary Date"]
              : "";
            obj.allergies = value[
              "Dietary Restrictions Or Physical Limitations"
            ]
              ? value["Dietary Restrictions Or Physical Limitations"]
              : "";
            obj.under_age_35 = value["Under Age 35"]
              ? value["Under Age 35"]
              : "";
            obj.emergency_name1 = value["Emergency Name1"]
              ? value["Emergency Name1"]
              : "";
            obj.emergency_relationship1 = value["Emergency Relationship1"]
              ? value["Emergency Relationship1"]
              : "";
            obj.emergency_phone1 = value["Emergency Phone1"]
              ? value["Emergency Phone1"]
              : "";
            obj.emergency_name2 = value["Emergency Name2"]
              ? value["Emergency Name2"]
              : "";
            obj.emergency_relationship2 = value["Emergency Relationship2"]
              ? value["Emergency Relationship2"]
              : "";
            obj.emergency_phone2 = value["Emergency Phone2"]
              ? value["Emergency Phone2"]
              : "";

            obj.hear_us = value["How did you hear about us?"]
              ? value["How did you hear about us?"]
              : "";

            obj.referral_from_a_friend_or_family_member = value[
              "Referral from a friend/family member"
            ]
              ? value["referral from a friend/family member"]
              : "";

            obj.notes = value["Notes"] ? value["Notes"] : "";
            if (value["Parish"]) {
              let findParish = parishList.find(
                (i) => i.parish == value["Parish"],
              );
              if (findParish && findParish !== undefined && findParish.id) {
                obj.parishId = findParish.id;
              } else {
                obj.parishId = "";
              }
            }
          } else {
            obj.primaryKey = "";
            obj.hisFirstName = value["His First Name"]
              ? value["His First Name"]
              : "";
            obj.hisLastName = value["His Last Name"]
              ? value["His Last Name"]
              : "";
            obj.hisEmail = value["His Email"] ? value["His Email"] : "";
            obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";

            obj.herFirstName = value["Her First Name"]
              ? value["Her First Name"]
              : "";
            obj.herLastName = value["Her Last Name"]
              ? value["Her Last Name"]
              : "";
            obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
            obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
            obj.address = value["Address"] ? value["Address"] : "";
            obj.city = value["City"] ? value["City"] : "";
            obj.state = value["State"] ? value["State"] : "";
            obj.zip = value["Zip"] ? value["State"] : "";
            obj.anniversary_date = value["Anniversary Date"]
              ? value["Anniversary Date"]
              : "";
            obj.allergies = value[
              "Dietary Restrictions Or Physical Limitations"
            ]
              ? value["Dietary Restrictions Or Physical Limitations"]
              : "";
            obj.under_age_35 = value["Under Age 35"]
              ? value["Under Age 35"]
              : "";
            obj.emergency_name1 = value["Emergency Name1"]
              ? value["Emergency Name1"]
              : "";
            obj.emergency_relationship1 = value["Emergency Relationship1"]
              ? value["Emergency Relationship1"]
              : "";
            obj.emergency_phone1 = value["Emergency Phone1"]
              ? value["Emergency Phone1"]
              : "";
            obj.emergency_name2 = value["Emergency Name2"]
              ? value["Emergency Name2"]
              : "";
            obj.emergency_relationship2 = value["Emergency Relationship2"]
              ? value["Emergency Relationship2"]
              : "";
            obj.emergency_phone2 = value["Emergency Phone2"]
              ? value["Emergency Phone2"]
              : "";
            obj.hear_us = value["How did you hear about us?"]
              ? value["How did you hear about us?"]
              : "";
            obj.referral_from_a_friend_or_family_member = value[
              "Referral from a friend/family member"
            ]
              ? value["referral from a friend/family member"]
              : "";
            obj.notes = value["Notes"] ? value["Notes"] : "";
            if (value["Parish"]) {
              let findParish = parishList.find(
                (i) => i.parish == value["Parish"],
              );
              if (findParish && findParish !== undefined) {
                obj.parishId = findParish.id;
              } else {
                obj.parishId = "";
              }
            }
          }
          importedData.push(obj);
        });
        saveCoupleExcel(importedData);
      }
    } catch (err) {
      toast.error(err.toString());
    }
    // setProcessing(false);
  };

  const saveCoupleExcel = async (importedData) => {
    const chunkSize = 10000;
    for (let i = 0; i < importedData.length; i += chunkSize) {
      const chunk = importedData.slice(i, i + chunkSize);
      await adminApi
        .saveCoupleExcel(chunk)
        .then(async (response) => {
          if (response.success) {
            if (response && response.mismatch.length) {
              setShow3(true);
              let arrayId = response.mismatch.join(",");
              let msg = `These couple have mismatch record.
              - \n\t
              ${arrayId}.
              So, these record are not inserted.`;
              setCoupleRepeatMsg(msg);
            }
            document.getElementById("fileUpload").value = "";
            getAllCouplesData(1, 20, "");
            checkPKCouple();
            toast.success("File data imported successfully");


          } else {
            document.getElementById("fileUpload").value = "";
            getAllCouplesData(1, 20, "");
            checkPKCouple();
            toast.error(response.msg);
          }
        })
        .catch((error) => {
          toast.error(error.toString());
          console.error("There is an error!", error);
        });
    }
  };

  const clickOnInputFile = () => {
    document.getElementById("fileUpload").click();
  };

  const downloadSampleExcel = async () => {
    const headings = [
      [
        "Couple Id",
        "His First Name",
        "His Last Name",
        "His Email",
        "His Mobile",
        "Her First Name",
        "Her Last Name",
        "Her Email",
        "Her Mobile",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "How did you hear about us?",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const data = [
      {
        primaryKey: "0001",
        hisLastName: "Paul",
        hisFirstName: "Sam",
        hisEmail: "sampaul@gmail.com",
        hisMobile: "210-323-0384",
        herLastName: "Adams",
        herFirstName: "Charisse",
        herEmail: "charisseAdams@gmail.com",
        herMobile: "210-459-4955",
        address: "101 Balistreri Overpass, Cummerataland, KY 42976",
        city: "Los Angeles",
        state: "California",
        zip_code: "123456",
        parish: "Holy Spirit",
        ainniversary_date: "04-02-2000",
        dietary_restrictions_or_physical_limitations:
          "Dietary restrictions or physical limitations",
        under_age_35: "NO",
        emergency_name_1: "cris",
        emergency_relationship_1: "friend",
        emergency_phone_1: "6445-7645-6786",
        emergency_name_2: "Eric",
        emergency_relationship_2: "Brother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: "School Marquee",
        Referral_from_a_friend_or_Family_member: "sister",
        notes: "Your notes here.",
      },
    ];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, "Sample Couple File.xlsx");

  };

  const isAdmin = userData && userData.userRole === "ADMIN";

  return (
    <div className="mc-page">
      <header className="mc-header">
        <div>
          <p className="mc-kicker">Couple management</p>
          <div className="mc-title-row">
            <h1 className="mc-title">
              {lastSegment === "missing-data" ? "Missing data" : "Couples"}
            </h1>
            <span className="mc-count">{total || 0}</span>
          </div>
        </div>
        <div className="mc-header-actions">
          <button
            type="button"
            className="mc-btn mc-btn-ghost"
            onClick={() => {
              setCoupleFilter("0");
              getAllCouplesData();
            }}
          >
            View all Couples
          </button>
          <button
            type="button"
            className="mc-btn mc-btn-primary"
            onClick={() => {
              setShowREgModal(true);
              checkPKCouple();
              clearfield();
            }}
          >
            <i className="mdi mdi-plus" />
            Create Couple
          </button>
          {isAdmin ? (
            <a className="mc-btn mc-btn-ghost" href="/priest-list">
              Spiritual Director (Priest/Deacon) List
            </a>
          ) : null}
        </div>
      </header>

      <div className="mc-toolbar">
        <label className="mc-field mc-field-search">
          <i className="mdi mdi-magnify" aria-hidden="true" />
          <input
            onChange={SearchData}
            type="search"
            placeholder="Search Couples"
            aria-label="Search Couples"
            value={searchKey}
          />
        </label>
        <Dropdown
          className="mc-filter-dropdown"
          onSelect={applyCoupleFilter}
        >
          <Dropdown.Toggle
            variant="light"
            id="mc-couple-filter"
            aria-label="Filter couples"
          >
            <span className="mc-filter-icon" aria-hidden="true">
              <i
                className={
                  coupleFilter === "1"
                    ? "mdi mdi-alert-circle-outline"
                    : "mdi mdi-account-group-outline"
                }
              />
            </span>
            <span className="mc-filter-copy">
              <span className="mc-filter-label">Show</span>
              <span className="mc-filter-value">
                {coupleFilter === "1" ? "Missing Data" : "All Couples"}
              </span>
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu align="start">
            <Dropdown.Item
              eventKey="0"
              active={coupleFilter === "0"}
              className="mc-filter-item"
            >
              <span className="mc-filter-item-icon" aria-hidden="true">
                <i className="mdi mdi-account-group-outline" />
              </span>
              <span className="mc-filter-item-copy">
                <strong>All Couples</strong>
                <small>Full Couple List</small>
              </span>
              {coupleFilter === "0" ? (
                <i className="mdi mdi-check mc-filter-check" aria-hidden="true" />
              ) : null}
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="1"
              active={coupleFilter === "1"}
              className="mc-filter-item"
            >
              <span className="mc-filter-item-icon is-alert" aria-hidden="true">
                <i className="mdi mdi-alert-circle-outline" />
              </span>
              <span className="mc-filter-item-copy">
                <strong>Missing data</strong>
                <small>Couples with incomplete records</small>
              </span>
              {coupleFilter === "1" ? (
                <i className="mdi mdi-check mc-filter-check" aria-hidden="true" />
              ) : null}
            </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        <div className="mc-missing-note">
          <span className="mc-missing-swatch" aria-hidden="true">
            ⚠ Missing
          </span>
          Yellow means missing required Couple data
        </div>
        {isAdmin ? (
          <div className="mc-toolbar-meta">
            <button
              type="button"
              className="mc-btn mc-btn-ghost"
              onClick={downloadSampleExcel}
            >
              Sample Excel
            </button>
            <button
              type="button"
              className="mc-btn mc-btn-ghost"
              onClick={clickOnInputFile}
            >
              <i className="mdi mdi-upload" />
              Import
            </button>
            <input
              className="btn btn-secondary"
              type="file"
              name="File Upload"
              id="fileUpload"
              hidden
              onChange={fileChangeListener}
              accept=".xlsx"
            />
            <Dropdown className="dropset">
              <Dropdown.Toggle
                className="btn btn-outline-secondary btn-sm"
                id="dropdown-basic"
              >
                <i className="mdi mdi-download" aria-hidden="true" />
                <span>Export</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <a onClick={handleExport}>
                  <Dropdown.Item>Excel</Dropdown.Item>
                </a>
                <a onClick={exportPdf}>
                  <Dropdown.Item>PDF</Dropdown.Item>
                </a>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : null}
      </div>

      <section className="mc-table-card" aria-label="Couple list">
        <CustomDataTable
          loading={LoadData}
          data={allCoupleData}
          columns={columns}
          total={total}
          countPerPage={20}
          isServerSide={true}
          pagination={true}
          sortServer={true}
          dataFetchApi={getAllCouplesData}
          conditionalRowStyles={conditionalRowStyles}
          pointerOnHover={true}
          highlightOnHover={true}
          parishValue={locationData?.state?.parishValue}
          forCouple={true}
          noDataComponent={
            <div className="mc-empty">
              <p>No couples to show</p>
              <span>Try another search or view all couples.</span>
            </div>
          }
        />
      </section>
        {show ? (
          <DeleteModel
            show={show}
            content={
              <>
                <h5 className="mt-4 fw-bold">Couple Detail</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* His Details */}
                  {(icon_id.hisFirstName ||
                    icon_id.hisLastName ||
                    icon_id.hisEmail) && (
                    <div className="mb-2">
                      <span className="fw-bold">His:</span>{" "}
                      {icon_id.hisFirstName} {icon_id.hisLastName}
                      {icon_id.hisEmail && (
                        <span className="text-muted">
                          {" "}
                          – {icon_id.hisEmail}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Her Details */}
                  {(icon_id.herFirstName ||
                    icon_id.herLastName ||
                    icon_id.herEmail) && (
                    <div>
                      <span className="fw-bold">Her:</span>{" "}
                      {icon_id.herFirstName} {icon_id.herLastName}
                      {icon_id.herEmail && (
                        <span className="text-muted">
                          {" "}
                          – {icon_id.herEmail}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </>
            }
            handleClose={handleClose}
            DeleteData={deleteCouple}
          ></DeleteModel>
        ) : null}
        {show1 ? (
          <AlertModal
            show={show1}
            handleClose={handleClose1}
            message={`Are you sure you want to ${
              changeText && changeText !== "" ? changeText : "make"
            } this couple as sub-admin?`}
            actionFunction={makeCoupleAsSubAdmin}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
        {show2 ? (
          <AlertModal
            show={show2}
            handleClose={handleClose2}
            message={`Are you sure you want to ${
              changeText && changeText !== "" ? changeText : "make"
            } this couple as super-admin?`}
            actionFunction={makeCoupleAsSubAdmin}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
        {showRegModal ? (
          <UpdateCouplePopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllCouplesData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            refreshRoastersOfCouple={getroastersOfCouple}
            getAllCouples={getAllCouplesData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null}

        {/* {showPriestREgModal ? (
          <UpdatePriestPopUp
            showRegModal={showPriestREgModal}
            setShowREgModal={setShowPriestREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllCouplesData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            getAllCouples={getAllCouplesData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null} */}

        {show3 ? (
          <AlertModal
            show={show3}
            handleClose={handleClose3}
            message={coupleRepeatMsg}
            actionFunction={handleClose3}
            cancel={"Cancel"}
            heading={"ALERT!!"}
            okay={"Okay"}
          />
        ) : null}
    </div>
  );
};

export default ManageCouples;
